import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Works\ValuationController::store
* @see app/Http/Controllers/Works/ValuationController.php:23
* @route '/works/{work}/valuations'
*/
export const store = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/works/{work}/valuations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\ValuationController::store
* @see app/Http/Controllers/Works/ValuationController.php:23
* @route '/works/{work}/valuations'
*/
store.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return store.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\ValuationController::store
* @see app/Http/Controllers/Works/ValuationController.php:23
* @route '/works/{work}/valuations'
*/
store.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\ValuationController::store
* @see app/Http/Controllers/Works/ValuationController.php:23
* @route '/works/{work}/valuations'
*/
const storeForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\ValuationController::store
* @see app/Http/Controllers/Works/ValuationController.php:23
* @route '/works/{work}/valuations'
*/
storeForm.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Works\ValuationController::update
* @see app/Http/Controllers/Works/ValuationController.php:34
* @route '/works/{work}/valuations/{valuation}'
*/
export const update = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/works/{work}/valuations/{valuation}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Works\ValuationController::update
* @see app/Http/Controllers/Works/ValuationController.php:34
* @route '/works/{work}/valuations/{valuation}'
*/
update.url = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            work: args[0],
            valuation: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
        valuation: typeof args.valuation === 'object'
        ? args.valuation.id
        : args.valuation,
    }

    return update.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace('{valuation}', parsedArgs.valuation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\ValuationController::update
* @see app/Http/Controllers/Works/ValuationController.php:34
* @route '/works/{work}/valuations/{valuation}'
*/
update.put = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Works\ValuationController::update
* @see app/Http/Controllers/Works/ValuationController.php:34
* @route '/works/{work}/valuations/{valuation}'
*/
const updateForm = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\ValuationController::update
* @see app/Http/Controllers/Works/ValuationController.php:34
* @route '/works/{work}/valuations/{valuation}'
*/
updateForm.put = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Works\ValuationController::destroy
* @see app/Http/Controllers/Works/ValuationController.php:45
* @route '/works/{work}/valuations/{valuation}'
*/
export const destroy = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/works/{work}/valuations/{valuation}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Works\ValuationController::destroy
* @see app/Http/Controllers/Works/ValuationController.php:45
* @route '/works/{work}/valuations/{valuation}'
*/
destroy.url = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            work: args[0],
            valuation: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
        valuation: typeof args.valuation === 'object'
        ? args.valuation.id
        : args.valuation,
    }

    return destroy.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace('{valuation}', parsedArgs.valuation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\ValuationController::destroy
* @see app/Http/Controllers/Works/ValuationController.php:45
* @route '/works/{work}/valuations/{valuation}'
*/
destroy.delete = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Works\ValuationController::destroy
* @see app/Http/Controllers/Works/ValuationController.php:45
* @route '/works/{work}/valuations/{valuation}'
*/
const destroyForm = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\ValuationController::destroy
* @see app/Http/Controllers/Works/ValuationController.php:45
* @route '/works/{work}/valuations/{valuation}'
*/
destroyForm.delete = (args: { work: string | { slug: string }, valuation: number | { id: number } } | [work: string | { slug: string }, valuation: number | { id: number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const valuations = {
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default valuations